import renderProduct from './services/productRenderer';
import { ProductProps } from './types/productProps';
import ProductWidget from './types/productWidget';

export default class Product implements ProductWidget {
    private readonly uuid: string;

    private props: ProductProps;

    public constructor(props: ProductProps) {
        this.props = props;
        this.uuid = this.props._.id;
        this.render();
    }

    public getProps = (): ProductProps => this.props;

    public render = (): void => renderProduct(this.getProps());
}
